import { render, staticRenderFns } from "./PubchemSectionInformation.vue?vue&type=template&id=1d71f169"
import script from "./PubchemSectionInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./PubchemSectionInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports